// add 181104
// written by concentinc
jQuery(function() {


    // must require 'KUTE.js'
    // [notice] 'style.css' was overridden for these processes.

    // inview animation for home page
        $('h2, p, b, strong, dl, ul, li, iframe, figure, .title-block, .cal, #shopify-section-1624501960853f5622')
            .css('opacity', 0)
            .one('inview', function( e, isIn, x, y ) {
                KUTE.fromTo(this, {
                    opacity: 0, translateY: 20
                }, {
                    opacity: 1, translateY: 0
                }, { duration: 1000, easing: 'easingSinusoidalOut' }).start();
            });
    if ( !/Edge\/\d+|MSIE|Windows/.test(navigator.userAgent) ) {

        $('body')
            .css('opacity', 0);

        $(document).ready(function(){

            KUTE.to( 'body', {
                opacity: 1
            }, { duration: 950, easing: 'easingSinusoidalOut' }).start();

            if ( $('.hero').length > 0 ) {
                KUTE.to('.hero', {
                    opacity: 1
                }, { duration: 500, easing: 'easingSinusoidalOut'}).start();

                KUTE.fromTo('.hero img', {
                    opacity: 0, translateY: 20
                }, {
                    opacity: 1, translateY: 0
                }, { duration: 700, easing: 'easingSinusoidalOut', delay: 400 }).start();
            } else if ( $('.fv').length > 0 ) {
                $('.fv').removeClass('fv-active');
            }
        });
    } else {

        $('body')
            .css('opacity', 1);
    }
});
